import { useExamDistributionByMonth } from '@exam-center/exam-distribution';
import { Flex, DateInput, Box } from '@shared/components';
import { dayjs } from '@shared/utils';

import { useExamDistributionSearchParams } from '../../hooks';
import { ExamCenterSearchSelection } from '../exam-center-search-selection';
import { ProvinceSearchSelection } from '../province-search-selection';

export default function ExamDistributionFilterSection() {
  const { year, month } = useExamDistributionByMonth();

  const defaultExamDate = dayjs()
    .set('year', year)
    .set('month', month - 1)
    .toDate();

  const [
    { examDate, examCenters, provinces },
    { changeExamDate, changeExamCenters, changeProvinces },
  ] = useExamDistributionSearchParams();

  return (
    <Flex sx={(theme) => ({ gap: theme.spacing(3) })}>
      <Box sx={{ width: '276px' }}>
        <DateInput
          label='วันที่สอบ'
          placeholder='แสดงทั้งหมด'
          inputFormat='DD-MM-YYYY'
          value={examDate}
          minDate={dayjs(defaultExamDate).startOf('month').toDate()}
          maxDate={dayjs(defaultExamDate).endOf('month').toDate()}
          initialMonth={defaultExamDate}
          onChange={(value) => {
            changeExamDate(value);
          }}
        />
      </Box>
      <ExamCenterSearchSelection
        value={examCenters}
        onChange={(value) => changeExamCenters(value)}
      />
      <ProvinceSearchSelection value={provinces} onChange={(value) => changeProvinces(value)} />
    </Flex>
  );
}
